// extracted by mini-css-extract-plugin
export var actionButton = "_hs-t";
export var buttonContainer = "_hs-0";
export var buttonContainer2 = "_hs-1";
export var buttonSection = "_hs-2";
export var details = "_hs-3";
export var dropdownItem = "_hs-5";
export var dropdownItemsContainer = "_hs-4";
export var fileInput = "_hs-r";
export var headerButton = "_hs-6";
export var icon = "_hs-7";
export var input = "_hs-8";
export var macroListItem = "_hs-9";
export var mainContent = "_hs-a";
export var microText = "_hs-b";
export var modal = "_hs-w";
export var optionsButton = "_hs-c";
export var paperclip = "_hs-s";
export var pillContent = "_hs-d";
export var preview = "_hs-e";
export var preview2 = "_hs-f";
export var quillEditor = "_hs-q";
export var selectedMacro = "_hs-g";
export var sidebar = "_hs-h";
export var sidebarHeader = "_hs-j";
export var sidebarList = "_hs-i";
export var sidebarListItem = "_hs-k";
export var sidebarSearch = "_hs-l";
export var snoozeDurationWrapper = "_hs-v";
export var statusPillContainer = "_hs-m";
export var tagsContainer = "_hs-n";
export var unselectedMacro = "_hs-o";
export var variable = "_hs-u";
export var wrapper = "_hs-p";